module.exports = __webpack_public_path__ + "img/finance-application-display-kia.03068ffa.png";